import Airtable from 'airtable';

import configs from '../../config';

/** Built from airtable documentation (requires 1password login to view) https://airtable.com/appoQ9I2TU8c6DDkj/api/docs */
export const appendDataToAirtable = (
  firstName: string,
  lastName: string,
  email: string,
  practiceId: string,
  options: { onSuccess: () => void; onError: () => void },
) => {
  const base = new Airtable({
    apiKey: configs.AIRTABLE_API_KEY,
  }).base(configs.AIRTABLE_BASE_ID);

  base('Users').create(
    [
      {
        fields: {
          fldZuKLUvkqxIdN9K: firstName,
          fldU8Xal2KzwI4YJA: lastName,
          fldAF1Vr4GXFsRjY2: email,
          fldrJqGy5zLzJwLA5: practiceId,
        },
      },
    ],
    { typecast: true },
    (err) => {
      if (err) {
        options.onError();
        throw new Error(err);
      }
      options.onSuccess();
    },
  );
};
